const STORAGE_KEY = "upch_perf_metrics";
const MOUNT_PREFIX = "upch_perf_mount_";
const DEBUG_KEY = "upch_perf_debug";

const obtenerMetricas = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
  } catch (error) {
    return [];
  }
};

const guardarMetrica = (metrica) => {
  const lista = obtenerMetricas();
  lista.push({ ...metrica, timestamp: new Date().toISOString() });
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(lista));
};

const limpiarMetricas = () => {
  sessionStorage.removeItem(STORAGE_KEY);
  Object.keys(sessionStorage)
    .filter((key) => key.startsWith(MOUNT_PREFIX))
    .forEach((key) => sessionStorage.removeItem(key));
};

// Mide el tiempo de red/backend de una llamada (desde que se dispara el fetch hasta que llega la respuesta).
const medirBackend = async (id, nombre, vista, fn) => {
  const inicio = performance.now();
  try {
    return await fn();
  } finally {
    guardarMetrica({
      id,
      nombre,
      vista,
      categoria: "Backend",
      duracionMs: performance.now() - inicio,
    });
  }
};

// Mide el tiempo que tarda React en confirmar y pintar el DOM luego de recibir datos (doble rAF = post-paint).
const medirFrontendRender = (id, nombre, vista, inicioMs) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      guardarMetrica({
        id,
        nombre,
        vista,
        categoria: "Frontend",
        duracionMs: performance.now() - inicioMs,
      });
    });
  });
};

// Cada vez que la vista monta se arranca desde 0: si no, recargar/volver a Inicio sumaría
// las llamadas de la visita anterior a las nuevas en vez de reemplazarlas.
const marcarInicioVista = (vista) => {
  limpiarMetricas();
  const inicio = performance.now();
  sessionStorage.setItem(`${MOUNT_PREFIX}${vista}`, String(inicio));
  return inicio;
};

// Cierra la medición "Total" de una vista: desde marcarInicioVista hasta el primer paint posterior a esta llamada.
const medirCargaTotalVista = (vista, nombre) => {
  const inicioStr = sessionStorage.getItem(`${MOUNT_PREFIX}${vista}`);
  if (!inicioStr) return;
  const inicio = Number(inicioStr);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      guardarMetrica({
        id: `${vista}_total`,
        nombre: nombre || `Vista ${vista} - Carga total`,
        vista,
        categoria: "Total",
        duracionMs: performance.now() - inicio,
      });
    });
  });
};

// Visibilidad del botón/herramientas de QA: se controla por sessionStorage, no por ambiente,
// para poder activarlo también en producción sin redeploy (solo dura la sesión del tab).
const estaPerfDebugActivo = () => sessionStorage.getItem(DEBUG_KEY) === "true";
const activarPerfDebug = () => sessionStorage.setItem(DEBUG_KEY, "true");
const desactivarPerfDebug = () => sessionStorage.removeItem(DEBUG_KEY);

// Helper de consola, disponible en cualquier ambiente. No mide ni exporta nada hasta que se active.
if (typeof window !== "undefined") {
  window.upchPerf = {
    activar: () => {
      activarPerfDebug();
      console.log("upchPerf: herramientas de QA activadas para esta pestaña. Recarga si el botón no aparece.");
    },
    desactivar: () => {
      desactivarPerfDebug();
      console.log("upchPerf: herramientas de QA desactivadas para esta pestaña.");
    },
    estado: () => estaPerfDebugActivo(),
    ver: () => {
      const datos = obtenerMetricas();
      console.table(datos);
      return datos;
    },
    exportar: (vista = "Inicio") =>
      import("./exportarMetricasExcel").then((m) => m.default(vista)),
    limpiar: limpiarMetricas,
  };
}

export {
  medirBackend,
  medirFrontendRender,
  marcarInicioVista,
  medirCargaTotalVista,
  obtenerMetricas,
  limpiarMetricas,
  estaPerfDebugActivo,
  activarPerfDebug,
  desactivarPerfDebug,
};
